import { Injectable } from '@angular/core'
import { DialogService } from '@tokeet-frontend/tv3-platform'
import { AutomationEventTypes, AutomationTypes } from '@tokeet-frontend/automations'
import { AutomationsWizardDialogComponent } from '@tv3/containers/automations/automations-wizard/automations-wizard-dialog.component'

@Injectable()
export class AutomationsWizardDialogService {
  constructor(private dialog: DialogService) {}

  open(data?: { type?: AutomationTypes; event?: AutomationEventTypes }) {
    return this.dialog.openVariableDialog(AutomationsWizardDialogComponent, {
      width: '90%',
      maxWidth: '1090px',
      height: 'auto',
      data: { ...data },
    })
  }
}
